import { render, staticRenderFns } from "./AdoptionProcedure.vue?vue&type=template&id=a8bbe01c&scoped=true"
import script from "./AdoptionProcedure.vue?vue&type=script&lang=js"
export * from "./AdoptionProcedure.vue?vue&type=script&lang=js"
import style0 from "./AdoptionProcedure.vue?vue&type=style&index=0&id=a8bbe01c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bbe01c",
  null
  
)

export default component.exports